export const storesData = [
  {
    id: 'SY7415',
    name: 'Sky Paan Fusion',
    location: '506 Cityscape Square NE, Calgary, AB T3N 2A8',
    menu: {
      // The menuData object our component expects
      images: [
        {
          id: "page1",
          desktopSrc: "/images/1.png",
          mobileSrc: "/images/1-m.png",
          alt: "Sky Paan Menu Page 1",
        },
        {
          id: "page2",
          desktopSrc: "/images/2.png",
          mobileSrc: "/images/2-m.png",
          alt: "Sky Paan Menu Page 1",
        },
        {
          id: "page3",
          desktopSrc: "/images/3.png",
          mobileSrc: "/images/3-m.png",
          alt: "Sky Paan Menu Page 1",
        },
        {
          id: "page4",
          desktopSrc: "/images/4.png",
          mobileSrc: "/images/4-m.png",
          alt: "Sky Paan Menu Page 1",
        },
        
        // Add as many pages/images as you need
      ],
    },
    pdfs: [
      { name: 'All Menu', url: '/pdfs/skypaan-menu.pdf' }
    ],
  },
];